'use strict';
/**
 * This function can only be used if bootstrap has been initialized on the page
 */
var $ = require('jquery');
var groupSchemeService = require('../../../../main/scripts/modules/services/groupSchemeService');
var dateUtils = require('shared/scripts/modules/utils/dateUtils');
var popover = require('../../../../main/scripts/modules/utils/popover');
require('jquery-mask-plugin');


function registerYesToggle(context) {
    $('[data-yes-show-input]', context).change(function(e) {
        var trigger = $(e.target);
        var idToShow = trigger.attr('data-yes-show-input');
        var $inputElement = $("#"+idToShow).val('');
        resetSelectPicker($inputElement);
        $inputElement.closest('.form-group').toggleClass('hidden', trigger.val() !== 'YES');
    });
}

function registerNoToggle(context) {
    $('[data-no-show-input]', context).change(function(e) {
        var trigger = $(e.target);
        var idToShow = trigger.attr('data-no-show-input');
        var $inputElement = $("#"+idToShow).val('');
        resetSelectPicker($inputElement);
        $inputElement.closest('.form-group').toggleClass('hidden', trigger.val() !== 'NO');
    });
}

function resetSelectPicker($element) {
    if ($element.is(".selectpicker")) {
        $element.selectpicker('val','');
    }
}

function applyMasks(context) {
    $('input.date-mask', context).mask('00/00/0000');
    $('.capital-mask', context).on('blur', function () {$(this).val($(this).val().charAt(0).toUpperCase() + $(this).val().slice(1) );});
}

/**
 * Gets the value of the changesEffectiveFromRenewalDate field from the Group Scheme Service
 * The value's context is the Group Scheme. It is set as a checkbox in GIOS and it indicates that the user will now be
 * given the option of selecting the Group's next renewal date as their policy start date
 * @param model
 * @param checkboxElement - form input checkbox element for the changesEffectiveFromRenewalDate field selection
 * @param checkboxMainContainerElement - the entire checkbox input row and text info relating to it
 */
function renderChangesEffectiveFromRenewalDateCheckboxElement(model, checkboxElement, checkboxMainContainerElement) {
    // set default value
    model.groupSchemeBasicInfoData = {changesEffectiveFromRenewalDate: false };
    //  get the changesEffectiveFromRenewalDate value from the session
    var groupSchemeBasicInfoPromise = groupSchemeService.getGroupScheme(true);
    $.when(groupSchemeBasicInfoPromise)
        .done(function(groupSchemeBasicInfoData) {
            model.renewalDate = groupSchemeBasicInfoData.renewalDate;
            model.groupSchemeBasicInfoData.changesEffectiveFromRenewalDate =
                groupSchemeBasicInfoData.changesEffectiveFromRenewalDate;

            // set checkbox ui elements
            popover.initPopOver();
            // checkbox may have been previously displayed and checked, so uncheck
            checkboxElement.prop('checked', false);

            if(model.groupSchemeBasicInfoData.changesEffectiveFromRenewalDate) {
                checkboxMainContainerElement.removeClass('hidden');
                $('#policyStartDateRow').addClass('shorten-height-minus-margin');
            } else {
                checkboxMainContainerElement.addClass('hidden');
                $('#policyStartDateRow').removeClass('shorten-height-minus-margin');
            }
        });
}

/**
 * Sets the click event listener for the checkbox
 * @param checkboxElement - form input checkbox element for the changesEffectiveFromRenewalDate field selection
 * @param startDatePicker
 * @param model
 * @param policyStartDateElement - startDate text input element
 * @param callback - resets Product Type and resets the startDatePicker dropdown
 */
function changesEffectiveFromRenewalDateSetClickEvent(checkboxElement, startDatePicker, model, policyStartDateElement,
                                                   callback) {
    checkboxElement.on('change', function(){
        var selected = checkboxElement.is(':checked');
        checkboxElement.prop('checked', selected);
        model.policyInfo.basicPolicyInfo.changesEffectiveFromRenewalDate = selected;

        if(selected) {
            startDatePicker.renderSingleDate(model.renewalDate);
            var date = new Date(model.renewalDate);
            var formattedDate = dateUtils.dateFormatDayMonthYear(date);
            var datePickerFormatted = $(policyStartDateElement).datepicker({ format: 'dd/mm/yyyy' });
            datePickerFormatted.datepicker('setDate', formattedDate);
            $(policyStartDateElement).prop('disabled', true);
            checkboxElement.val(true);
        } else {
            // reset datepicker back to correct range for selected product
            if(callback) { callback(); }
            $(policyStartDateElement).prop('disabled', false);
            checkboxElement.val(false);
        }
    });
}

function trimElementValue(elementId) {
    $(elementId).val($(elementId).val().trim());
}

function trimInput(elementId) {
    if($('[id^='+elementId+']').length) {
        $('[id^='+elementId+']').each(function(){
            trimElementValue($(this));
        });
    }
}


module.exports.registerYesToggle = registerYesToggle;
module.exports.registerNoToggle = registerNoToggle;
module.exports.applyMasks = applyMasks;

module.exports.renderChangesEffectiveFromRenewalDateCheckboxElement = renderChangesEffectiveFromRenewalDateCheckboxElement;
module.exports.changesEffectiveFromRenewalDateSetClickEvent = changesEffectiveFromRenewalDateSetClickEvent;
module.exports.trimElementValue = trimElementValue;
module.exports.trimInput = trimInput;



//////////////////
// WEBPACK FOOTER
// ./src/shared/scripts/modules/forms/inputHelper.js
// module id = LaRm
// module chunks = 1 2